export const    CLEAR_RESOURCE = "CLEAR_RESOURCE",
                EDIT_RESOURCE = "EDIT_RESOURCE",

                SAVE_RESOURCE_REQUEST = "SAVE_RESOURCE_REQUEST",
                SAVE_RESOURCE_SUCCESS = "SAVE_RESOURCE_SUCCESS",
                SAVE_RESOURCE_FAILURE = "SAVE_RESOURCE_FAILURE",
                
                FLAG_RESOURCE_REQUEST = "FLAG_RESOURCE_REQUEST",
                FLAG_RESOURCE_SUCCESS = "FLAG_RESOURCE_SUCCESS",
                FLAG_RESOURCE_FAILURE = "FLAG_RESOURCE_FAILURE",

                SEARCH_RESOURCE_REQUEST = "SEARCH_RESOURCE_REQUEST",
                SEARCH_RESOURCE_SUCCESS = "SEARCH_RESOURCE_SUCCESS",
                SEARCH_RESOURCE_FAILURE = "SEARCH_RESOURCE_FAILURE",
                
                ADD_REMOVE_TAG_REQUEST = "ADD_REMOVE_TAG_REQUEST",
                ADD_REMOVE_TAG_SUCCESS = "ADD_REMOVE_TAG_SUCCESS",
                ADD_REMOVE_TAG_FAILURE = "ADD_REMOVE_TAG_FAILURE",

                SORT_RESOURCE_REQUEST = "SORT_RESOURCE_REQUEST",
                SORT_RESOURCE_SUCCESS = "SORT_RESOURCE_SUCCESS",
                SORT_RESOURCE_FAILURE = "SORT_RESOURCE_FAILURE";


/* Resources */
export function saveResourceRequest(id, resource) {
    return {
        type: SAVE_RESOURCE_REQUEST,
        resource,
        id
    };
}
export function saveResourceSuccess(response) {
    return {
        type: SAVE_RESOURCE_SUCCESS,
        resource: response.resource
    };
}
export function saveResourceFailure(responseStatus) {
    return {
        type: SAVE_RESOURCE_FAILURE,
        responseStatus
    };
}

export function flagResourceRequest(id, resourceId) {
    return {
        type: FLAG_RESOURCE_REQUEST,
        id,
        resourceId
    };
}
export function flagResourceSuccess(response) {
    return {
        type: FLAG_RESOURCE_SUCCESS,
        resource: response.resource
    };
}
export function flagResourceFailure(responseStatus) {
    return {
        type: FLAG_RESOURCE_FAILURE,
        responseStatus
    };
}

export function searchResourceRequest(id, term) {
    return {
        type: SEARCH_RESOURCE_REQUEST,
        id,
        term
    };
}
export function searchResourceSuccess(response) {
    return {
        type: SEARCH_RESOURCE_SUCCESS,
        resources: response.resources
    };
}
export function searchResourceFailure(responseStatus) {
    return {
        type: SEARCH_RESOURCE_FAILURE,
        responseStatus
    };
}

export function clearResource() {
    return {
        type: CLEAR_RESOURCE,
    };
}
export function editResource(resourceId, confirmDelete) {
    return {
        type: EDIT_RESOURCE,
        resourceId,
        confirmDelete
    };
}


/* Attach Tags */
export function saveResourceTagRequest(resourceId, tagId) {
    return {
        type: ADD_REMOVE_TAG_REQUEST,
        resourceId,
        tagId
    };
}

export function saveResourceTagSuccess(response) {
    return {
        type: ADD_REMOVE_TAG_SUCCESS,
        tag: response.tag,
        resourceId: response.id
    };
}

export function saveResourceTagFailure(responseStatus) {
    return {
        type: ADD_REMOVE_TAG_FAILURE,
        responseStatus
    };
}



export function sortResourceRequest(forumId, resourceId, newIndex) {
    return {
        type: SORT_RESOURCE_REQUEST,
        forumId,
        resourceId,
        newIndex
    };
}
export function sortResourceSuccess(response) {
    return {
        type: SORT_RESOURCE_SUCCESS,
        resources: response.resources
    };
}
export function sortResourceFailure(responseStatus) {
    return {
        type: SORT_RESOURCE_FAILURE,
        responseStatus
    };
}


// WEBPACK FOOTER //
// ./src/actions/resources.actions.ts